import { Route, Routes } from "react-router-dom";
import HSTSLogin from "./auth/login";
import ResetPassword from "./auth/resetPassword";
import AdminHome from "./dashbroad/admin/adminHome";
import { Auth } from "./utils/auth";
import UserPassword from "./dashbroad/admin/userPassword";
import ManageStudent from "./dashbroad/admin/manageStudent";
import ManageCoordinator from "./dashbroad/admin/manageCoordinator";
import RegisterCoordinator from "./dashbroad/admin/registerCoordinator";
import CoordinatorHome from "./dashbroad/coordinator/Home";
import ManageStudentC from "./dashbroad/coordinator/manageStudentC";
import ChangePassword from "./dashbroad/coordinator/changePassword";
import MyProfile from "./dashbroad/coordinator/myProfile";
import RegisterStudent from "./dashbroad/coordinator/registerStudent";
import StudentDetails from "./dashbroad/coordinator/studentDetails";
import StudentHome from "./dashbroad/student/studentHome";
import StudentAccount from "./dashbroad/student/account";
import ChangePasswordS from "./dashbroad/student/changePasswordS";
import MyStudy from "./dashbroad/student/myStudy";
import NotFound from "./utils/404";
import RegisterProgress from "./dashbroad/student/registerProgress";
import ManageProgress from "./dashbroad/student/manageProgress";
import ManageProgressC from "./dashbroad/coordinator/manageProgressC";
import ViewProgressC from "./dashbroad/coordinator/viewProgressC";
import StudentDetailsA from "./dashbroad/admin/studentDetailsA";
import ManageProgressA from "./dashbroad/admin/manageProgressA";
import ViewProgressA from "./dashbroad/admin/viewProgressA";
import EditProgress from "./dashbroad/student/editProgress";
import UpdateCoordinator from "./dashbroad/admin/updateCoordinator";

const AppRoutes = () => {
  const ROLES = {
    Admin: "ROLE_ADMIN",
    Coordinator: "ROLE_COORDINATOR",
    Student: "ROLE_STUDENT",
  };

  return (
    <Routes>
      <Route path="/" element={<HSTSLogin />} />
      <Route path="/resetPassword" element={<ResetPassword />} />

      {/* ===== Admin paths  ===== */}
      <Route
        path="/admin"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <AdminHome />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/student"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <ManageStudent />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/coordinator"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <ManageCoordinator />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/addCoordinator"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <RegisterCoordinator />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/coordinatorDetails/:id"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <UpdateCoordinator />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/studentDetails/:id"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <StudentDetailsA />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/viewProgress/:id"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <ManageProgressA />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/viewProgress/details/:id"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <ViewProgressA />
          </Auth>
        }
      ></Route>
      <Route
        path="/admin/password"
        element={
          <Auth allowedRoles={[ROLES.Admin]}>
            <UserPassword />
          </Auth>
        }
      ></Route>

      {/* ===== Coordinator paths ===== */}
      <Route
        path="/coordinator"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <CoordinatorHome />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/student"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <ManageStudentC />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/password"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <ChangePassword />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/profile"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <MyProfile />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/addStudent"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <RegisterStudent />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/studentDetails/:id"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <StudentDetails />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/viewProgress/:id"
        element={
          <Auth allowedRoles={[ROLES.Coordinator]}>
            <ManageProgressC />
          </Auth>
        }
      ></Route>
      <Route
        path="/coordinator/viewProgress/details/:id"
        element={
          <Auth allowedRoles={[ROLES.Coordinator, ROLES.Admin]}>
            <ViewProgressC />
          </Auth>
        }
      ></Route>

      {/* ===== Student paths ===== */}
      <Route
        path="/student"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <StudentHome />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/profile"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <StudentAccount />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/password"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <ChangePasswordS />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/study"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <MyStudy />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/addProgress/:id"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <RegisterProgress />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/viewProgress/:id"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <ManageProgress />
          </Auth>
        }
      ></Route>
      <Route
        path="/student/editProgress/:id"
        element={
          <Auth allowedRoles={[ROLES.Student]}>
            <EditProgress />
          </Auth>
        }
      ></Route>

      {/* 404 Page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
